import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login.jsx";
import AdminRoute from "./AdminRoute";
import SuiviProduction from "./pages/SuiviProduction/SuiviProduction.jsx";
import Facturation from "./pages/Facturation/Facturation.jsx"; // <--- IMPORT
import Archives from "./pages/Archives/Archives.jsx";
import Notes from "./pages/Notes/Notes.jsx";
const Router = () => {
    return (
        <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />

            {/* Protégé : Suivi de Production */}
            <Route
                path="/suivi-production"
                element={
                    <AdminRoute>
                        <SuiviProduction />
                    </AdminRoute>
                }
            />

            {/* Protégé : Facturation (NOUVEAU) */}
            <Route
                path="/facturation"
                element={
                    <AdminRoute allowBilling>
                        <Facturation />
                    </AdminRoute>
                }
            />
            <Route
                path="/archives"
                element={
                    <AdminRoute>
                        <Archives />
                    </AdminRoute>
                }
            />
            <Route
                path="/notes"
                element={
                    <AdminRoute>
                        <Notes/>
                    </AdminRoute>
                }
            />
            {/* Redirections */}
            <Route path="/" element={<Navigate to="/suivi-production" />} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export default Router;
